module.exports = __webpack_public_path__ + "img/mockup-5.190612ee.png";